import {registerCrudStore} from '@/libs/core/+state/register-crud-store';
import {BusinessModule} from '@/libs/core/models/business-module';
import { ApplicationUserModel, TenantUserModel } from '@/libs/Api';
import { ApplicationUserDataService } from '../application-user-data-service';
import { TenantConnectionsDataService } from '../tenant-connections-data-service';

export const applicationUserStore = registerCrudStore<ApplicationUserModel, ApplicationUserModel>(BusinessModule.ApplicationUser, new ApplicationUserDataService());
export const tenantConnectionsStore = registerCrudStore<TenantUserModel, TenantUserModel>(BusinessModule.TenantConnection, new TenantConnectionsDataService());